import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import CommissionTable from './CommissionTable';
import CommissionOverview from './CommissionOverview';
import { commissionType } from './CommissionPropTypes';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import { Button, ButtonGroup,  Image, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import { CommissionCurrencyFilter } from './CommissionCurrencyFilter';

class Commissions extends React.Component {


   constructor(props){
     super(props);
     this.state = {
        filter: {},
        search:'',
        commissions:[],
      };
      
      this.downloadCommissionXls = this.downloadCommissionXls.bind(this);
      this.currencyFilterSet = this.currencyFilterSet.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.flag = false
   }

  componentWillMount() {
    // if (this.props.needFetch) {
    //   this.props.requestCommission(0);
    // }
    this.setState({commissions:this.props.commissions})
  }
 
  // componentWillReceiveProps(nextProps) {
  //   if (this.props.id !== nextProps.id) {
  //     if (nextProps.id) {
  //       this.props.selectBooking(nextProps.id);
  //     }
  //   } else if (nextProps.id && nextProps.selectedBooking.needFetch) {
  //     this.props.requestBooking(nextProps.id);
  //   }
  // }
   downloadCommissionXls() {
    const payload = { format: 'application/vnd.ms-excel', report: 'commission' };
    console.log('downloadHotelXls called');
    this.props.exportCommissionList(this.props.id,payload);
  }
  currencyFilterSet(currencyFilter, key){
    this.props.currencyFilterSet(currencyFilter);
  }
   handleChange(e){
    this.flag =true
    const query = e.target.value;
    const commissions = this.props.commissions;
    console.log(commissions)
    const newCommissions = commissions.filter((item)=>{
      let hotel = item.bid.hotel.name.toLowerCase().indexOf(query.toLowerCase())!== -1;
      let tour = item.tour.toLowerCase().indexOf(query.toLowerCase())!== -1;
      let state;
      if (query.toLowerCase() === 'due') {
        state = item.state.toLowerCase() === 'due';
      } else if (query.toLowerCase() === 'overdue') {
        state = item.state.toLowerCase() === 'overdue';
      } else {
        state = item.state.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      }
      
      let due = new Date(item.due).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).toLowerCase().indexOf(query.toLowerCase()) !== -1;

      let end = new Date(item.bid.bidset.event.end).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).toLowerCase().indexOf(query.toLowerCase())!== -1;
      return hotel?hotel:tour?tour:state?state:due?due:end?end:'';
    })
    this.setState({
          search:e.target.value,
          commissions:newCommissions,
    })
  }
  

  render() {
    const comm = this.state.commissions;
    const commissions = comm.length >= 0 &&this.flag?comm:this.props.commissions;
    this.flag = false
    // if (this.props.hasError) {
    //   return (
    //     <Layout>
    //       <Error />
    //     </Layout>
    //   );
    // }
    // if (this.props.needFetch || this.props.isFetching) {
    //   return (
    //     <Layout>
    //       <Loading />
    //     </Layout>
    //   );
    // }
    if (this.props.id) {
      return (
        <Layout>
          <div>
            {this.props.children}
          </div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="container-fluid">
          <div className="panel proposal-header planner col-sm-12 commission">
            <CommissionOverview
              requestCommissionOverview={this.props.requestCommissionOverview}
              commissions={this.props.commissions}
              currencyFilter={this.props.currencyFilter}
              commissionOverview={this.props.commissionOverview}
            /><br/>
            <FormGroup>
              <FormControl
                type="text"
                value={this.state.search}
                placeholder="Search Commission By Hotel Name, Tour Name, Status & Check In/Out. "
                onChange={this.handleChange}
              />
            </FormGroup>

            <ButtonGroup>

              <Button id = {this.props.id} 
                       onClick={this.downloadCommissionXls}
                       bsStyle="info"
                       >
                       <i className="fa fa-address-card fa-lg" /> Export
              </Button>
              <a id="commissions-data-link" />
              <CommissionCurrencyFilter
                currencyFilter={this.props.currencyFilter}
                currencyFilterSet={this.currencyFilterSet}
              />
            </ButtonGroup>
            <CommissionTable
              commissions={commissions}
              editCommission={this.props.editCommission}
              removeCommission={this.props.removeCommission}
              count={this.props.count}
              currencyFilter={this.props.currencyFilter}
              requestCommission={this.props.requestCommission}
              downloadCommissionInvoice={this.props.downloadCommissionInvoice}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Commissions.propTypes = {
  commissions: PropTypes.arrayOf(
    PropTypes.shape({ commissionType }),
  ).isRequired,
  id: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  requestCommission: PropTypes.func.isRequired,
  editCommission: PropTypes.func.isRequired,
  filter: PropTypes.object,
  currencyFilterSet: PropTypes.func.isRequired,
  currencyFilter: PropTypes.func.isRequired,
};

export default Commissions;



// WEBPACK FOOTER //
// src/routes/commissions/components/Commissions.js